export const getRatingLineBackgroundColor = (value, filled) => {
	const rating = Math.round(value);
	if (rating === 1) {
		return filled ? '#FB306D' : '#FECBDA';
	}
	if (rating >= 2 && rating <= 3) {
		return filled ? '#FDB400' : '#FEECBF';
	}
	return filled ? '#14BF96' : '#C4EFE4';
};

export const getRatingIconVariant = (value) => {
	const rating = Math.round(value);
	if (rating === 1) {
		return 'red';
	}
	if (rating >= 2 && rating <= 3) {
		return 'yellow';
	}
	return 'green';
};
